import Matter from 'matter-js'

export default {

    beforeDestroy() {

        this.$events.removeListener('animate', this.animate)
        this.$events.removeListener('click', this.click)
        _.each(this.$sprites_background, (sprite)=>{ this.$background.removeChild(sprite) })
        _.each(this.$sprites_foreground, (sprite)=>{ this.$foreground.removeChild(sprite) })  
        if(this.$tween) this.$tween.kill()
    },

    created() {

        this.$pixi = this.$parent.$pixi
        this.$events = this.$parent.$events
        this.$Engine = this.$parent.$Engine
        this.$World = this.$parent.$World
        this.$Bodies = this.$parent.$Bodies
        this.$Body = this.$parent.$Body
        this.$Events = this.$parent.$Events
        this.$engine = this.$parent.$engine
        this.$world = this.$parent.$world
        this.$champagne = this.$parent.$champagne
        this.$background = this.$parent.$background
        this.$foreground = this.$parent.$foreground
        this.$width = this.$parent.$width
        this.$height = this.$parent.$height 
        this.$sprites_background = []
        this.$sprites_foreground = []
        this.$coef = this.$parent.$coef

        this.$himself_touch =  0x0004
        this.$generic_touch =  0x0006
    },

    mounted() {

        this.$events.on('animate', this.animate)
        this.$events.on('click', this.click)
    },

    methods: {

        click() {
        },
    }

}


